var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8945_17723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4257 5.16013L13.4244 4.49346C13.4226 3.56004 13.4217 3.09333 13.2393 2.73717C13.079 2.42387 12.8235 2.16939 12.5096 2.01021C12.1527 1.82924 11.686 1.83014 10.7526 1.83194L9.41926 1.8345C8.48584 1.8363 8.01913 1.8372 7.66296 2.01954C7.34967 2.17993 7.09519 2.43539 6.936 2.7493C6.75503 3.10617 6.75593 3.57288 6.75773 4.5063L6.75901 5.17296M8.4345 9.75308L8.44252 13.9197M11.7678 9.74666L11.7758 13.9133M2.59235 5.18098L17.5923 5.15211M15.9257 5.15532L15.9436 14.4886C15.9463 15.8888 15.9477 16.5888 15.6762 17.1241C15.4374 17.595 15.0557 17.9782 14.5858 18.2188C14.0515 18.4923 13.3515 18.4936 11.9513 18.4963L8.28468 18.5034C6.88455 18.5061 6.18448 18.5074 5.64918 18.236C5.17832 17.9972 4.79513 17.6155 4.55454 17.1455C4.28103 16.6113 4.27968 15.9112 4.27698 14.5111L4.25902 5.17777",
    stroke: "#F7F9F9",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8945_17723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.0839844 1.01904) rotate(-0.110297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.e35fd674f8734514a6d7ab4d5293638a.svg";
export { ForwardRef as ReactComponent };